<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title><span [innerHTML]="title | safeHTML"></span></h1>
    <div class="scroll" fxFlex fxLayout="column" fxLayoutAlign="start stretch">
        <p [innerHTML]="message | safeHTML"></p>
        <div *ngIf="ShowSearch">
            <form [formGroup]="SearchForm" novalidate>
                <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="20px"
                    fxLayout.lt-md="column"
                    fxLayoutAlign.lt-md="start stretch"
                >
                    <mat-form-field>
                        <input
                            type="search"
                            matInput
                            formControlName="LastName"
                            placeholder="Last Name"
                            (keyup.enter)="HandleUserKey($event)"
                            autofocus
                        />
                    </mat-form-field>
                    <mat-form-field>
                        <input
                            type="search"
                            matInput
                            formControlName="FirstName"
                            placeholder="First Name"
                            (keyup.enter)="HandleUserKey($event)"
                        />
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" style="align-self:center">
                    <button
                        type="button"
                        color="primary"
                        mat-raised-button
                        (click)="HandleUserSearch()"
                        [disabled]="!SearchReady || SearchForm.invalid"
                    >
                        Search
                    </button>
                    <button type="button" color="warn" mat-raised-button style="margin-left:30px" (click)="SearchForm.reset()">
                        Reset
                    </button>
                </div>
            </form>
        </div>
        <div *ngIf="SmallDisplay && UserSearchConducted" class="centered">
            <button type="button" color="primary" mat-raised-button (click)="ShowSearchForm()">Search Again</button>
        </div>
        <div [hidden]="UserSearchConducted !== true" fxFlex>
            <mat-table class="bordered" #table [dataSource]="UserData">
                <ng-container matColumnDef="LastName">
                    <mat-header-cell *matHeaderCellDef class="centered">Last Name</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{ user.LastName | titleCase }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="FirstName">
                    <mat-header-cell *matHeaderCellDef class="centered">First Name</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{ user.FirstName | titleCase }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="City">
                    <mat-header-cell *matHeaderCellDef class="centered">City</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{ user.City }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Email">
                    <mat-header-cell *matHeaderCellDef class="centered">Email</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{ user.Email }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Username">
                    <mat-header-cell *matHeaderCellDef class="centered">Username</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">{{ user.Username }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
                    <mat-cell *matCellDef="let user" class="centered">
                        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px" class="margin-top margin-bottom">
                            <button *ngIf="DesigneeMode" mat-raised-button color="primary" (click)="DesigneeOKHandler(user, false)">
                                Select
                            </button>
                            <button *ngIf="!DesigneeMode" mat-raised-button color="primary" (click)="OKHandler(user, 0)">
                                <span>Add As Support Staff</span>
                            </button>
                            <button *ngIf="!DesigneeMode" mat-raised-button color="primary" (click)="OKHandler(user, 1)">
                                <span>Add As Advisor</span>
                            </button>
                            <button
                                *ngIf="!DesigneeMode && CanAddAsAdministrator === true"
                                mat-raised-button
                                color="accent"
                                (click)="OKHandler(user, 2)"
                            >
                                Add As Admin
                            </button>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="NoData">
                    <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
                    <mat-cell *matCellDef="let user"
                        ><em>No search results were found with the provided search criteria.</em></mat-cell
                    >
                </ng-container>

                <ng-container matColumnDef="SmallDisplay">
                    <mat-header-cell *matHeaderCellDef>Search Result(s)</mat-header-cell>
                    <mat-cell *matCellDef="let user">
                        <div fxLayout="column" fxLayoutAlign="start stretch">
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>Last Name</form-label>
                                <div>{{ user.LastName | titleCase }}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>First Name</form-label>
                                <div>{{ user.FirstName | titleCase }}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>City</form-label>
                                <div>{{ user.City }}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>Email</form-label>
                                <div>{{ user.Email }}</div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between start">
                                <form-label>Username</form-label>
                                <div>{{ user.Username }}</div>
                            </div>
                            <div class="margin-top margin-bottom" fxLayout="column" fxLayoutAlign="start center">
                                <button
                                    *ngIf="DesigneeMode"
                                    mat-raised-button
                                    color="primary"
                                    (click)="DesigneeOKHandler(user, false)"
                                >
                                    <span>Select</span>
                                </button>
                                <button *ngIf="!DesigneeMode" mat-raised-button color="primary" (click)="OKHandler(user, 0)">
                                    <span>Add As Support Staff</span>
                                </button>
                                <button *ngIf="!DesigneeMode" mat-raised-button color="primary" (click)="OKHandler(user, 1)">
                                    <span>Add As Advisor</span>
                                </button>
                                <button
                                    *ngIf="!DesigneeMode && CanAddAsAdministrator === true"
                                    mat-raised-button
                                    color="accent"
                                    (click)="OKHandler(user, 2)"
                                >
                                    Add As Admin
                                </button>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
                <mat-row *matRowDef="let row; columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></mat-row>
            </mat-table>
            <mat-paginator
                #paginator
                [length]="UserData.data.length"
                [pageIndex]="0"
                [pageSize]="5"
                [pageSizeOptions]="[5, 10, 25, 100]"
            ></mat-paginator>
        </div>
    </div>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button color="warn" mat-raised-button (click)="CancelHandler()"><span [innerHTML]="canceltext | safeHTML"></span></button>
        <button color="accent" *ngIf="DesigneeMode && UserSearchConducted" mat-raised-button (click)="DesigneeHandler()">
            Create New Account
        </button>
    </mat-dialog-actions>
</div>



// WEBPACK FOOTER //
// ./src/services/dialogs/usersearch/usersearch.dialogcomponent.html